export default __webpack_public_path__ + "static/media/209-2097878_laundry-dry-cleaning-cleaning-and-laundry-logo-png.5480945f.png";